import React, { useEffect, useState } from 'react';
import { FormControlLabel, Switch } from "@mui/material";
import { useUpdateAccount } from "queries/accounts";
import { useAgencyInfo } from "context/agency";

const Apps = ({ formData }) => {
    const [allowedApps, setAllowedApps] = useState([]);
    const [agency] = useAgencyInfo();
    const AIApps = [
        {
            "label": "Your AI",
            "value": "AI Social App"
        },
    ];

    useEffect(() => {
        // Initialize the allowed apps with the formData.apps on component mount
        setAllowedApps(formData?.apps || []);
    }, [formData]);

    const handleToggleChange = (name) => {
        setAllowedApps((prevApps) => {
            const updatedApps = prevApps.includes(name)
                ? prevApps.filter(item => item !== name)
                : [...prevApps, name];

            // Call AccountUpdate with the updated list
            AccountUpdate(updatedApps);
            return updatedApps;
        });
    };

    const { mutateAsync: updateAppsMutation } = useUpdateAccount();

    const AccountUpdate = async (updatedApps) => {
        const payload = {
            apps: updatedApps,
            _id: formData.id
        };
        const { response } = await updateAppsMutation(payload);
        if (response) {
            // Handle success if needed
        }
    };

    return (
        <div>
            {AIApps.map((item, index) => (
                <div
                    key={index}
                    style={{
                        marginBottom: "10px",
                        borderRadius: '10px',
                        border: "1px solid rgba(229, 229, 229, 1)",
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between"
                    }}
                >
                    <p className="px-5-dd text-left font-bold" style={{ width: "25%" }}>{item.label}</p>
                    <p className="px-5-dd text-left font-bold" style={{ width: "75%", textAlign: "right" }}>
                        <FormControlLabel control={<Switch checked={allowedApps.includes(item.value)} onChange={() => handleToggleChange(item.value)} />} label=""
                        />
                    </p>
                </div>
            ))}
        </div>
    );
};

export default Apps;
